import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  badge: 'New',
  title: 'Add a custom screensaver to Zeller Terminal.',
  description:
    'Personalise Zeller Terminal with your business logo or add a marketing message with a custom screensaver.',
  point1: 'Upload a logo in Zeller Dashboard to display on Zeller Terminal.',
  point2: 'Display a logo, seasonal message, or promotional offer.',
  point3: 'Custom screensavers appear on Terminal within seconds.',
  point4: 'Update your screensaver as frequently as you like.',
  ctaDescription:
    'Screensavers are applied to your Zeller Terminal at a Site level. To get started, go to Sites in your Zeller Dashboard, select a Site, then select “Appearance”. ',
  primaryButtonLabel: 'View My Sites',
  secondaryButtonLabel: 'Close',
})
